var exports = {
  "k": "xe564cbfb--ab0104--container",
  "M": "xe564cbfb--ab0104--container--inner",
};

module.exports = exports;
